export enum HeaderCallDialerTab {
    LAST_CALL = "last-call",
    DIALER = "dialer",
}

export enum HeaderCallDialerVariant {
    TABS = "tabs",
    LAST_CALL = "last-call",
    DIALER = "dialer",
}

export type HeaderCallDialerContentProps = {
    variant?: HeaderCallDialerVariant;
};
